import React, { useState, useMemo, useEffect } from 'react';
import Icon from '../Icon';
import {
  CheckboxIconWrapper,
  StyledCheckbox,
  StyledCheckboxIcon,
  StyledCheckboxWrapper,
} from './styles/Inputs.styled';
import { InputProps } from './types/Input.types';

const Checkbox: React.FC<
  InputProps & React.InputHTMLAttributes<HTMLInputElement>
> = ({
  inputSize = 'medium',
  inputState = 'default',
  wrapperClassName,
  label,
  message,
  helperText,
  showMessageIcon = true,
  ...props
}) => {
  // const [checked, setChecked] = useState<boolean>(
  //   props.checked ?? props.value == 'on'
  // );
  // const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   props.onChange && props.onChange(e);
  //   // setChecked(e.target.checked);
  // };

  const messageIcon = useMemo(() => {
    switch (inputState) {
      case 'default':
      default:
        return null;

      case 'success':
        return <Icon name="check-circle" />;

      case 'error':
      case 'warning':
        return <Icon name="warning" />;
    }
  }, [inputState]);

  return (
    <StyledCheckboxWrapper
      className={wrapperClassName}
      $inputSize={inputSize}
      $inputState={inputState}
    >
      <label htmlFor={props.id}>
        <CheckboxIconWrapper>
          <StyledCheckbox
            type="checkbox"
            $inputSize={inputSize}
            $inputState={inputState}
            {...props}
            // onChange={onChange}
          />
          <StyledCheckboxIcon name="check" $checked={props.checked ?? false} />
        </CheckboxIconWrapper>
        {label && <span>{label}</span>}
      </label>
      {helperText && <span className="helper-text">{helperText}</span>}
      {message && (
        <div className="message">
          {showMessageIcon && messageIcon}
          <span>{message}</span>
        </div>
      )}
    </StyledCheckboxWrapper>
  );
};

export default Checkbox;
